'use client'

import type { DocumentSnapshot } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { doc, getFirestore } from 'firebase/firestore'
import { useMemo } from 'react'
import { useDocument } from 'react-firebase-hooks/firestore'

type CompanyDoc = {
  isTenantMaintenanceHidden?: boolean
}

export function resolveTenantMaintenanceVisibility(
  tenantId: string | null | undefined,
  loading: boolean,
  error: Error | undefined | null,
  snapshot: DocumentSnapshot | undefined
): { isHidden: boolean; isLoading: boolean } {
  const isLoading = Boolean(tenantId && loading)
  if (!tenantId) {
    return { isHidden: false, isLoading: false }
  }
  if (error) {
    return { isHidden: true, isLoading: false }
  }
  if (loading) {
    return { isHidden: false, isLoading }
  }
  if (!snapshot?.exists()) {
    return { isHidden: false, isLoading: false }
  }
  const data = snapshot.data() as CompanyDoc
  return { isHidden: data.isTenantMaintenanceHidden === true, isLoading: false }
}

export function useIsTenantMaintenanceHidden(tenantId: string | null | undefined) {
  const docRef = useMemo(() => {
    if (!tenantId) return undefined
    const db = getFirestore(getAuth().app)
    return doc(db, 'companies', tenantId)
  }, [tenantId])

  const [snapshot, loading, error] = useDocument(docRef)

  return useMemo(
    () => ({
      ...resolveTenantMaintenanceVisibility(tenantId, loading, error, snapshot),
      error,
    }),
    [tenantId, loading, error, snapshot]
  )
}
